import {KTSVG} from '../../../_metronic/helpers'
import React, {
  FC,
  useEffect,
  useState,
  useCallback,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react'
import {Modal} from 'react-bootstrap'
import Select from 'react-select'
import axios from 'axios'
import {useMemo} from 'react'
import {useAuth} from '../../../app/modules/auth'
import { randomUUID } from 'crypto';
import { useReactToPrint } from 'react-to-print';


type Props = {
  statedeletingproduct: boolean
  cannotDeleteproduct: boolean
  show: boolean
  handleClose: () => void
  producttodelete: any
  deleteselectedproduct: () => void

}

const API_URL = process.env.REACT_APP_API_URL
const CURRENCY_APP = process.env.REACT_APP_CURRENCY
export const Deleteproduct: FC<Props> = forwardRef((props, ref) => {
  



  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
        <h3 className='fw-bolder'>Delete Product
          <span className='h-10px border-gray-200 border-start mx-2'></span>

           <span className='text-muted fw-bold fs-6'>{props.producttodelete.product_id}</span>
          
          </h3>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
        <div className='fv-row mb-7'>
              <div className='card bg-light'>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='required card-label fw-bolder fs-5 mb-1'>Product Description</span>
                    <span className='text-muted mt-1 fw-bold fs-7'>
                    {props.producttodelete.product_name}
                    </span>
                  </h3>
                  
                </div>
                {/* end::Header */}
                {/* begin::Body */}
                <div className='card-body py-3 mb-5'>
                <div dangerouslySetInnerHTML={{ __html: props.producttodelete.product_description }} />
                </div>
                {/* begin::Body */}
              </div>
            </div>

          <span className='required fw-bold fs-5 mb-2'>
            Are you sure you want to delete the above product ?
          </span>
         

    
       
       {props.cannotDeleteproduct && 
        <div className='alert alert-danger mt-5'>
          <div className='alert-text font-weight-bold'>There are some sales products with this ID, therefore it cannot be deleted</div>
        </div>
       
        }

        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Cancel
          </button>
          <button
            id='submit'
            type='button'
            className='btn btn-danger'
            onClick={props.deleteselectedproduct}
            disabled={props.statedeletingproduct}
         
          >
             {!props.statedeletingproduct && <span className='indicator-label'>Delete Product</span>}
            {props.statedeletingproduct && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
          </button>
        </div>
      </div>

      
    </Modal>
    
  )
})
